/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageMaterialResponse
 */
export interface LanguageMaterialResponse {
    /**
     * 
     * @type {string}
     * @memberof LanguageMaterialResponse
     */
    typeOther?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageMaterialResponse
     */
    score?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageMaterialResponse
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageMaterialResponse
     */
    separatedScore?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageMaterialResponse
     */
    language?: LanguageMaterialResponseLanguageEnum;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof LanguageMaterialResponse
     */
    attachments?: Array<Attachment>;
    /**
     * 
     * @type {Option}
     * @memberof LanguageMaterialResponse
     */
    type?: Option;
}

/**
* @export
* @enum {string}
*/
export enum LanguageMaterialResponseLanguageEnum {
    Ja = 'Ja',
    En = 'En'
}

export function LanguageMaterialResponseFromJSON(json: any): LanguageMaterialResponse {
    return LanguageMaterialResponseFromJSONTyped(json, false);
}

export function LanguageMaterialResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageMaterialResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'typeOther': !exists(json, 'typeOther') ? undefined : json['typeOther'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'separatedScore': !exists(json, 'separatedScore') ? undefined : json['separatedScore'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(AttachmentFromJSON)),
        'type': !exists(json, 'type') ? undefined : OptionFromJSON(json['type']),
    };
}

export function LanguageMaterialResponseToJSON(value?: LanguageMaterialResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'typeOther': value.typeOther,
        'score': value.score,
        'level': value.level,
        'separatedScore': value.separatedScore,
        'language': value.language,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(AttachmentToJSON)),
        'type': OptionToJSON(value.type),
    };
}


